import React from 'react';

import { JobType, QaAnalysisJob } from 'interfaces/job';
import JobReportTab from './JobReportTab';

interface Props {
  pageSize?: number;
  selectedStudyId?: string;
}

const QaAnalysis: React.FunctionComponent<React.PropsWithChildren<Props>> = ({ pageSize = 10, selectedStudyId }) => {
  return (
    <JobReportTab<QaAnalysisJob>
      tabTitle="QA Analysis"
      jobType={JobType.QaAnalysis}
      emptyStateMessage="No QA analysis results are available yet."
      pageSize={pageSize}
      selectedStudyId={selectedStudyId}
    />
  );
};

export default QaAnalysis;
